import React from "react";
import { zl } from "../../../../functions/utilities.js";
import { useNavigate } from "react-router-dom";
import { dataCzas } from "../../../../functions/dataFormat.js";

const WspolnotaRozliczenieZaleglosciTBody = (props) => {

  const { tablica, handleCheckSms, handleCheckEmail, zaleglosciPowiadomienia } = props;

  const navigate = useNavigate();

  const lista = tablica && tablica?.map( (t, i) => {

    const handleLink = (link_wspolnota, link_user, link_grupa) => navigate(`/mieszkancy?idw=${link_wspolnota}`, { state: { link_user, link_grupa } });

    const powiadomienie = zaleglosciPowiadomienia && zaleglosciPowiadomienia?.find( z => z?.id_user == t?.czynsz?.id_user);
    let powiadomienieInfo = '';
    if (powiadomienie?.uwagi && powiadomienie?.uwagi.length > 0) {
      powiadomienieInfo = powiadomienie.uwagi;
    } else {
      powiadomienieInfo = powiadomienie ? `${dataCzas(powiadomienie.data_utworzenia)} / ${zl(powiadomienie.kwota)} / ${powiadomienie.kanal}` : 'Brak'
    }
    

    return (
      <tr key={i}>
        <td>
          {t.mieszkaniec}
        </td>
        <td 
          className="u pointer"
          style={{whiteSpace: "nowrap"}}
          onClick={()=>handleLink(t.czynsz?.mieszkaniec?.id_wspolnoty, t.czynsz?.mieszkaniec?.id_user, t.czynsz?.grupa_numer)}
        >
          {`${t?.adres}`} <br/> {`(grupa numer: ${t?.czynsz?.grupa_numer})`}
        </td>
        <td>
          {zl(t?.czynsz?.suma)}
        </td>
        <td>
          {zl(t?.przelewySuma_g)}
        </td>
        <td style={{whiteSpace: "nowrap"}}>
          <span style={t?.saldo < 0 ? {color: "red"} : {}}>
            { zl(t?.saldo) }
          </span>
        </td>
        <td>
          { `${zl(t?.czynsz?.ostatniCzynsz?.czynsz_na_msc)} /`} <br/> {`${zl(t?.czynsz?.dwukrotnoscOstatniegoCzynszu)}`}
        </td>
        {/* <td style={{textAlign: "center"}}>
          { rodzajPowiadomienia }
        </td> */}
        <td style={{textAlign: "center"}}>
          <input
            type="checkbox"
            checked={t.czyWyslacEmail}
            onChange={()=>handleCheckEmail(t.id)}
          />
        </td>
        <td style={{textAlign: "center"}}>
          <input
            type="checkbox"
            checked={t.czyWyslacSms}
            onChange={()=>handleCheckSms(t.id)}
          />
        </td>
        <td style={{maxWidth: "500px"}}>
          { t?.trescSms }
        </td>
        <td>
          {powiadomienieInfo}
        </td>
      </tr>
    )
  });

  return (
    <tbody>
      {lista}
    </tbody>
  )
}

export default WspolnotaRozliczenieZaleglosciTBody;